import { useMemo } from "react";
import { Link } from "react-router-dom";
import { CategoryProfileRelatedChart } from "@apiHooks/useCategoryProfileDetails";
import { getRandomItems } from "@helpers";
import { routeNames } from "@core/routeNames";
import ProfileSidebarSection from "@components/ProfileSidebarSection/ProfileSidebarSection";
import "./RelatedCharts.styles.scss";

interface Props {
    charts: CategoryProfileRelatedChart[];
}

const RelatedCharts = ({ charts }: Props) => {
    const items = useMemo(() => getRandomItems(charts, 5), [charts]);

    if (items.length === 0) return null;

    return (
        <ProfileSidebarSection className="RelatedCharts" title="RELATED CHARTS & DATA">
            <div className="RelatedCharts__list">
                {items.map(({ id, name, subCategoryName }) => (
                    <Link
                        key={id}
                        className="RelatedCharts__link"
                        to={{
                            pathname: routeNames.instantCharts,
                            search: `?q=${encodeURIComponent(name)}&id=${encodeURIComponent(id)}`
                        }}
                    >
                        {subCategoryName ? `${subCategoryName}: ${name}` : name}
                    </Link>
                ))}
            </div>
        </ProfileSidebarSection>
    );
};

export default RelatedCharts;
